// Angular
import { NgModule } from '@angular/core';
import { Router, RouterModule, UrlSerializer } from '@angular/router';
import { HttpModule, Http } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';


// RxJS
// import '@api/rxjs-operators';

// NRGX
import { Store } from '@ngrx/store';

// Celine
import { CelineAppModule } from '@api/base-app.module';

// Celine services
import { AuthenticationService, MenuService, RouterService, DashboardService } from '@api/services/index';
import { ModuleLoaderService } from "@api/index";

// Threshold services
import { AuthenticationConnectedService } from './authentication-threshold.service';
import { MenuConnectedService } from './menu-threshold.service';
import { RouterConnectedService } from './router-threshold.service';
import { HttpThresholdService } from './http-threshold.service';
import { DashboardThresholdService } from './dashboard-threshold.service';
import { AppThresholdConfigService } from './app-threshold-config.service';
import { FGWService } from './fgw.service';
import { UIEnvironmentService } from './ui-environment.service';
import { FeatureToggleService } from './feature-toggle.service';
import { NewRelicService } from '../services/new-relic.service';
import { UserProfileService } from './user-profile.service';
import { TextEncoderService } from './text-encoder.service';
import { ConnectionService } from './connection-service.service';
import { ExperienceService } from './experience.service';
import { HistoryService } from './history.service';
import { PortalMessageService } from './portal-messages.service';


let PROVIDERS = [
	ExperienceService,
	FGWService,
	AppThresholdConfigService,
	HttpThresholdService,
	{
		provide: AuthenticationService,
		useFactory: () => new AuthenticationConnectedService()
	},
	{
		provide: MenuService,
		useFactory: (http: Http) => new MenuConnectedService(http),
		deps: [Http]
	},
	{
		provide: RouterService,
		useFactory: (experienceService: ExperienceService, http: Http, router: Router, moduleLoaderService: ModuleLoaderService, store: Store<any>) => new RouterConnectedService(experienceService, http, router, moduleLoaderService, store),
		deps: [ExperienceService, Http, Router, ModuleLoaderService, Store]
	},
	{
		provide: DashboardService,
		useClass: DashboardThresholdService
	},
	UIEnvironmentService,
	FeatureToggleService,
	NewRelicService,
	UserProfileService,
	TextEncoderService,
	{
		provide: ConnectionService,
		useFactory: (http: Http) => new ConnectionService(http),
		deps: [Http]
	},
	HistoryService,
	PortalMessageService
];

@NgModule({
	imports: [
		HttpClientModule,
		CelineAppModule,
		RouterModule
	],
	providers: PROVIDERS
})

export class ThresholdServicesModule { }

export * from './authentication-threshold.service';
export * from './menu-threshold.service';
export * from './router-threshold.service';
export * from './dashboard-threshold.service';
export * from './fgw.service';
export * from './http-threshold.service';
export * from './ui-environment.service';
export * from './user-profile.service';
export * from './new-relic.service';
export * from './text-encoder.service';
export * from './history.service';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/index.ts